module.exports = __webpack_public_path__ + "static/media/download_icn.ca8aa3f5.png";